import React, { useEffect, useState } from "react";
import { Container, Image, Nav, Navbar } from "react-bootstrap";
import { Link, NavLink, useLocation } from "react-router-dom";
import "../App.css";

const navItems = [
  { label: "Home", to: "/", end: true },
  { label: "About", to: "/about" },
  { label: "Products", to: "/category" },
  { label: "News & Events", to: "/news" },
  { label: "Careers", to: "/career" },
];

const NavigationBar = () => {
  const [expanded, setExpanded] = useState(false);
  const { pathname } = useLocation();

  const closeNavbarAfterNavigation = () => {
    setExpanded(false);
    window.setTimeout(() => setExpanded(false), 0);
  };

  useEffect(() => {
    closeNavbarAfterNavigation();
  }, [pathname]);

  return (
    <Navbar
      expand="lg"
      sticky="top"
      expanded={expanded}
      onToggle={setExpanded}
      collapseOnSelect
      className={`site-navbar bg-white border-bottom shadow-sm py-2 ${
        expanded ? "site-navbar--open" : "site-navbar--closed"
      }`}
    >
      <Container>
        <Navbar.Brand
          as={Link}
          to="/"
          onClick={closeNavbarAfterNavigation}
          className="d-inline-flex align-items-center p-0"
        >
          <Image
            src="/assets/logo.png"
            alt="PT Bintang Anugerah Sukses"
            className="site-navbar__logo"
          />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="site-navbar-nav"
          aria-label="Toggle navigation"
          className="rounded-3"
        />

        <Navbar.Collapse id="site-navbar-nav">
          <Nav
            className="ms-auto align-items-lg-center gap-lg-1 pt-3 pt-lg-0"
            onClickCapture={closeNavbarAfterNavigation}
            onSelect={closeNavbarAfterNavigation}
          >
            {navItems.map((item) => (
              <Nav.Link
                key={item.to}
                eventKey={item.to}
                as={NavLink}
                to={item.to}
                end={item.end}
                onClick={closeNavbarAfterNavigation}
                className="site-nav-link rounded-3 fw-bold px-3 py-2"
              >
                {item.label}
              </Nav.Link>
            ))}
            <Nav.Link
              eventKey="/contact"
              as={NavLink}
              to="/contact"
              onClick={closeNavbarAfterNavigation}
              className="site-navbar__cta rounded-3 fw-bold px-3 py-2 text-center"
            >
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
